module.exports = __webpack_public_path__ + "static/img/module1.011e4d1c.jpg";